import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar'
import Sidebar from '../Sidebar'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';
import Config from '../Config';

function Socialhubview() {

    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();
    let { id } = useParams();

    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }
    const [version, setVersion] = useState([]);
  
    const getinfo = async (e) => {
        const res = await fetch(`${Config.apiurl}/api/v1/crm/social-hub/video/${id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        });
        if (res.status === 200 ) {
          const data = await res.json();
    
          setVersion(data.data);
    
        } 
        else if(res.status === 401){
          handleUnauthorized();
          getinfo();
        }
        else {
          alert("error");
    
        }
      };

      useEffect(()=>{
        getinfo();
     },[])
  return (
    <div className="container-scroller">
    <Navbar />

    <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
            <div className="content-wrapper">
                <div className='view_page_top'>
                    <Link to="/videos">Video list</Link>
                    <Link to={"/edit-video/" + id}>Edit</Link>
                </div>
                <div className="row">
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">Video View page</h4>

                                <div className='row view_div_row'>
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6>Title </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p> {version.videoTitle}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Type</h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p>  {version.videoType}</p>
                                            </div>
                                        </div>
                                    </div>
                                  
                                    <div className='col-12'>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6>Video</h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <video  className="video_previews" 
                                                 key={version?.url}
                                                width="300" controls onError={(e) => console.log("Video load error", e)}>
                                                <source src={version?.url} type="video/mp4" />
                                                {/* <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" />                                                Your browser does not support the video tag. */}
                                                </video>
                                            </div>
                                        </div>
                                    </div>
                                
                                    <div className='col-12'>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Thumbnail</h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <img  className="video_previews"  src={version?.thumbnail} alt="Thumbnail Preview" width="150" />
                                            </div>
                                        </div>
                                    </div>

                                      <div className='col-12'>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6>Status</h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                 <p>{version?.status ? 'Active' : 'Inactive'}</p>
                                            </div>
                                        </div>
                                    </div>
                               
                                     
                                     
                                   
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default Socialhubview
